<template>
  <base-form
    ref="form"
    has-captcha
    :items="data"
    label-width="2em"
    submit-text="登 录"
    @submit="onSubmit"
  />
</template>
<script>
import { mixinForward } from "@/mixins/mixinForward";
import { mapActions } from "vuex";
import BaseForm from "@/components/BaseForm";
import fallback from "@/utils/fallback";
export default {
  name: "AccountLogin",
  components: { BaseForm },
  data() {
    return {
      disabled: false, // 提交按钮禁用状态
      data: [{ name: "username" }, { name: "accountPassword" }]
    };
  },
  mixins: [mixinForward],
  mounted() {
    // 初使化 md5
    if (!window.hex_md5) fallback("md5");
    this.data[0].value = this.$route.query.account
      ? this.$route.query.account
      : "";
  },
  methods: {
    ...mapActions(["Login"]),
    /**
     * @description 步骤提交
     * @param {object} formdata  - 表单对象值
     * @param {object} validate  - 极致验证
     * @param {function} callback - 回调函数
     */
    onSubmit(formdata, validate, callback) {
      const params = Object.assign(
        {},
        {
          login_code: formdata.username,
          password: window.hex_md5(formdata.accountPassword)
        },
        validate || {}
      );
      this.Login({ params, callback })
        .then(() => {
          if (this.forward) {
            location.href = this.forward;
          } else {
            this.$router.replace(
              this.$route.query.redirect || {
                path: this._anchor.profile.path
              }
            );
          }
        })
        .catch(() => {})
        .finally(() => {
          if (this.$refs.form) {
            if (this.$refs.form.validator.type !== "aliyun2.0") {
              this.$refs.form.validator.reset();
            }
            this.$refs.form.disabled = false;
          }
        });
    }
  }
};
</script>
